import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsComponent } from './pages/forms/forms.component'
import { LoginComponent } from './pages/login/login.component';
import { CustomerComponent } from './pages/customer/customer.component';
import { AuthGuard } from './auth/auth.guard';
import { ScheduleAppointmentComponent } from './pages/schedule-appointment/schedule-appointment.component'
import { ViewOnlyComponent } from './pages/view-only/view-only.component';
import { AdminComponent } from './pages/admin/admin.component'

const routes: Routes = [
  
  // We don't need to protect this route because this is just viewing an empty form template 
  { path: 'forms/:formId/artist/:artistId', component: FormsComponent, canActivate: [AuthGuard] },
  { path: 'forms/services/:serviceIds/artist/:artistId/appointment/:appointmentId/:formId', component: FormsComponent, canActivate: [AuthGuard] },
  { path: 'forms/services/:serviceIds/artist/:artistId/appointment/:appointmentId', component: FormsComponent, canActivate: [AuthGuard] },

  // View Only Pages

  { path: ':formId/viewOnly', component: ViewOnlyComponent },
  { path: ':formId/viewOnly/:filledFormId', component: ViewOnlyComponent },

  { path: 'login', component: LoginComponent },  
  { path: ':artistId/admin', component: AdminComponent },
  { path: ':artistId/appointment', component: ScheduleAppointmentComponent, canActivate: [AuthGuard] },  
  { path: ':artistId/:viewstate/appointment/:appointmentId', component: CustomerComponent, canActivate: [AuthGuard] },
  { path: ':artistId/:viewstate', component: CustomerComponent, canActivate: [AuthGuard] },
  
  { path: ':artistId', component: CustomerComponent, canActivate: [AuthGuard] },  
  { path: '', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
